import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import client from '../api/client';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/blog/').then(res => setPosts(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>Blog — Tradrin Trading Simulator</title>
        <meta name="description" content="Articles about trading, technical analysis, trader psychology and trading strategies. By Tradrin." />
        <link rel="canonical" href="https://tradrin.com/blog" />
      </Helmet>
      <div className="landing">
        <nav className="landing-nav">
          <Link to="/" className="landing-logo">Tradrin</Link>
          <div className="landing-nav-links">
            <Link to="/">Home</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/login" className="landing-nav-login">Sign In</Link>
          </div>
        </nav>
        <div className="blog-page">
          <h1>Blog</h1>
          <p className="blog-subtitle">Articles about trading, strategies and technical analysis</p>
          {loading ? <p>Loading...</p> : posts.length === 0 ? (
            <div className="blog-empty">No articles yet. Come back soon!</div>
          ) : (
            <div className="blog-grid">
              {posts.map(post => (
                <Link key={post.id} to={`/blog/${post.slug}`} className="blog-card">
                  {post.cover_image && <img src={post.cover_image} alt={post.title} className="blog-card-img" />}
                  <div className="blog-card-body">
                    <div className="blog-card-tags">{post.tags && post.tags.split(',').map(t => <span key={t} className="blog-tag">{t.trim()}</span>)}</div>
                    <h2>{post.title}</h2>
                    <p>{post.excerpt}</p>
                    <span className="blog-card-date">{new Date(post.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
        <footer className="landing-footer">
          <div className="landing-footer-bottom">
            <span>&copy; {new Date().getFullYear()} Tradrin. All rights reserved.</span>
          </div>
        </footer>
      </div>
    </>
  );
}
